@if (isUpdateAvailable()) {
<div class="update-notification">
  <div class="flex align-items-center gap-2">
    <i class="pi pi-refresh animate-spin"></i>
    <span>{{ 'COMMON.UPDATE_AVAILABLE' | translate }}</span>
  </div>
  <button type="button" class="update-btn" (click)="updateApp()">{{ 'COMMON.UPDATE_NOW' | translate }}</button>
</div>
}

@if (isLoggedIn() && !isAuthPage()) {
<div class="app-shell" [class.nav-expanded]="isDesktopNavExpanded()" [class.rtl]="languageService.currentLanguage() === 'ar'">
  <aside class="desktop-rail" aria-label="Primary navigation">
    <button type="button" class="rail-toggle" (click)="toggleDesktopNav()" [attr.aria-expanded]="isDesktopNavExpanded()">
      @if (languageService.currentLanguage() === 'ar') {
      <i class="pi" [class.pi-angle-double-left]="!isDesktopNavExpanded()"
        [class.pi-angle-double-right]="isDesktopNavExpanded()"></i>
      } @else {
      <i class="pi" [class.pi-angle-double-right]="!isDesktopNavExpanded()"
        [class.pi-angle-double-left]="isDesktopNavExpanded()"></i>
      }
    </button>

    <div class="rail-search">
      <i class="pi pi-search"></i>
      <input type="search" [value]="navSearchQuery()" placeholder="Search menu"
        (input)="updateNavSearch($any($event.target).value)" />
      @if (navSearchQuery()) {
      <button type="button" class="nav-search-clear" aria-label="Clear menu search" (click)="clearNavSearch()">
        <i class="pi pi-times"></i>
      </button>
      }
    </div>

    <nav class="rail-nav">
      @for (item of filteredShellMenuItems(); track item.label) {
      <div class="rail-item-wrap" [class.has-children]="getChildItems(item).length > 0"
        [class.expanded]="isMenuExpanded(item)">
        <a class="rail-item" [class.active]="isActiveMenuItem(item)"
          [routerLink]="getChildItems(item).length > 0 ? null : getRouterPath(item)" [attr.aria-label]="item.label"
          (click)="getChildItems(item).length > 0 && toggleMenuGroup(item, $event)">
          <i [class]="item.icon"></i>
          <span class="rail-label">{{ item.label }}</span>
          @if (getChildItems(item).length > 0) {
          <i class="pi pi-chevron-right rail-caret" [class.expanded]="isMenuExpanded(item)"></i>
          }
        </a>

        @if (getChildItems(item).length > 0) {
        <div class="rail-flyout">
          <div class="flyout-title">{{ item.label }}</div>
          @for (child of getChildItems(item); track child.label) {
          <a class="flyout-link" [class.active]="isActiveMenuItem(child)" [routerLink]="getRouterPath(child)">
            <i [class]="child.icon"></i>
            <span>{{ child.label }}</span>
          </a>
          }
        </div>
        }
      </div>
      }
    </nav>
  </aside>

  <div class="shell-main">
    <header class="top-app-bar">
      <div class="app-bar-left">
        <button type="button" class="mobile-menu-btn" (click)="openMobileNav()" aria-label="Open navigation">
          <i class="pi pi-bars"></i>
        </button>

        <div class="brand-lockup cursor-pointer" routerLink="/">
          <img src="assets/images/loadgate-new-logo.png" alt="LoadGate" />
          <span>{{ 'APP.NAME' | translate }}</span>
        </div>

        <div class="page-context">
          <span>{{ currentPageTitle() }}</span>
        </div>
      </div>

      @if (customer(); as currentCustomer) {
      <div class="app-bar-actions">
        @if (canInstallPwa() && !isPwaInstalled()) {
        <button type="button" class="install-btn" (click)="promptInstallPwa()"
          [attr.aria-label]="'COMMON.INSTALL_APP' | translate" [attr.title]="'COMMON.INSTALL_APP' | translate">
          <i class="pi pi-download"></i>
          <span>{{ 'COMMON.INSTALL_APP' | translate }}</span>
        </button>
        }

        <button type="button" class="support-btn" (click)="openSupportChat()">
          <i class="fa-solid fa-headset"></i>
          <span>{{ 'MENU.CONTACT_SUPPORT' | translate }}</span>
        </button>

        @if (currentCustomer.company; as company) {
        <button type="button" class="company-logo-btn" [routerLink]="['/company']" aria-label="Company profile">
          @if (company.logo; as companyLogo) {
          <img [src]="companyLogo" alt="Company Logo" />
          } @else {
          <span class="company-logo-fallback">{{ (company.name || 'C').charAt(0) }}</span>
          }
          <span class="company-name">{{ company.name }}</span>
        </button>
        }

        <button type="button" class="user-profile-btn" (click)="profileMenu.toggle($event)">
          <p-avatar
            [image]="currentCustomer?.imageUrl ?? 'https://api.dicebear.com/7.x/avataaars/svg?seed=' + currentCustomer?.name"
            shape="circle">
          </p-avatar>
          <div class="user-info-text">
            <span class="user-name">{{ currentCustomer?.name }}</span>
            <span class="user-role">{{ 'COMMON.PREMIUM_MEMBER' | translate }}</span>
          </div>
          <i class="pi pi-chevron-down profile-chevron"></i>
        </button>

        <p-menu #profileMenu [model]="profileMenuItems()" [popup]="true" appendTo="body"></p-menu>
      </div>
      }
    </header>

    <main class="app-content" [class.rtl]="languageService.currentLanguage() === 'ar'">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<p-drawer [visible]="isMobileNavVisible()" (visibleChange)="isMobileNavVisible.set($event)"
  [position]="drawerPosition()" styleClass="mobile-nav-drawer">
  <ng-template pTemplate="header">
    <div class="drawer-brand">
      <img src="assets/images/loadgate-new-logo.png" alt="LoadGate" />
      <span>{{ 'APP.NAME' | translate }}</span>
    </div>
  </ng-template>

  <nav class="drawer-nav" aria-label="Mobile navigation">
    <div class="drawer-search">
      <i class="pi pi-search"></i>
      <input type="search" [value]="navSearchQuery()" placeholder="Search menu"
        (input)="updateNavSearch($any($event.target).value)" />
      @if (navSearchQuery()) {
      <button type="button" class="nav-search-clear" aria-label="Clear menu search" (click)="clearNavSearch()">
        <i class="pi pi-times"></i>
      </button>
      }
    </div>

    @for (item of filteredShellMenuItems(); track item.label) {
    <section class="drawer-nav-group" [class.expanded]="isMenuExpanded(item)">
      @if (getChildItems(item).length === 0) {
      <a class="drawer-link primary" [class.active]="isActiveMenuItem(item)" [routerLink]="getRouterPath(item)"
        (click)="closeMobileNav()">
        <i [class]="item.icon"></i>
        <span>{{ item.label }}</span>
      </a>
      } @else {
      <button type="button" class="drawer-group-title" [class.active]="isActiveMenuItem(item)"
        (click)="toggleMenuGroup(item, $event)" [attr.aria-expanded]="isMenuExpanded(item)">
        <i [class]="item.icon"></i>
        <span>{{ item.label }}</span>
        <i class="pi pi-chevron-down drawer-caret" [class.expanded]="isMenuExpanded(item)"></i>
      </button>
      @if (isMenuExpanded(item)) {
      @for (child of getChildItems(item); track child.label) {
      <a class="drawer-link child" [class.active]="isActiveMenuItem(child)" [routerLink]="getRouterPath(child)"
        (click)="closeMobileNav()">
        <i [class]="child.icon"></i>
        <span>{{ child.label }}</span>
      </a>
      }
      }
      }
    </section>
    }
  </nav>
</p-drawer>
} @else {
<main class="app-content" [class.rtl]="languageService.currentLanguage() === 'ar'">
  <router-outlet></router-outlet>
</main>
}
